import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'solicitudes',
})
export class SolicitudesPipe implements PipeTransform {

  transform(items: any[], filter: {local: number; menu: string}) {

    if (items) {

      if (filter.local) {
        items = items.filter((item) => item.id_local == filter.local);
      }

      if (filter.menu) {
        items = items.filter((item) => filter.menu === 'pendientes' ? item.id_estado === 0 : item.id_estado === 1);
      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/solicitudes/solicitudes.ts